import { useState } from 'react'

export function useTextareaFocusHandler(autoFocus = false) {
  const [focused, setFocused] = useState(autoFocus)

  function handleBlur() {
    setFocused(false)
  }

  function handleFocus() {
    setFocused(true)
  }

  return { focused, handleBlur, handleFocus }
}
